import produce from "immer";
import {enableES5} from "immer";
import {createAction, handleActions} from 'redux-actions';

enableES5();

const initialState = {
    now: 'collection',
    config: {},
    isAllowed: true,
    isParamsLoaded: false,

    query: '',
    job: '',
    page: 1,

    jobData: [],
    compare: false,
    char: '',
    recentChar: {}
};

// actions--------------------------------------------------------------------------------
export const actions = {
    setConfig: createAction('GI_L2M_P/SET_CONFIG'),
    setIsParamsLoaded: createAction('GI_L2M_P/SET_IS_PARAMS_LOADED'),
    setIsAllowed: createAction('GI_L2M_P/SET_IS_ALLOWED'),

    setQuery: createAction('GI_L2M_P/SET_QUERY'),
    setJob: createAction('GI_L2M_P/SET_JOB'),
    setPage: createAction('GI_L2M_P/SET_PAGE'),
    setJobData: createAction('GI_L2M_P/SET_JOBDATA'),

    setCompare: createAction('GI_L2M_P/SET_COMPARE'),
    setChar: createAction('GI_L2M_P/SET_CHAR'),
    setRecentChar: createAction('GI_L2M_P/SET_RECENTCHAR'),
};

// handlers--------------------------------------------------------------------------------
export default handleActions({
    [actions.setConfig] : (state, action) => produce(state, draft => {draft.config = action.payload;}),
    [actions.setIsParamsLoaded] : (state, action) => produce(state, draft => {draft.isParamsLoaded = action.payload;}),
    [actions.setIsAllowed] : (state, action) => produce(state, draft => {
        console.log('???', action.payload);
        if (typeof action.payload === 'boolean') {
            draft.isAllowed = action.payload;
        } else {
            draft.isAllowed = true;
        }
    }),

    [actions.setQuery] : (state, action) => produce(state, draft => {draft.query = action.payload;}),
    [actions.setJob] : (state, action) => produce(state, draft => {draft.job = action.payload;}),
    [actions.setJobData] : (state, action) => produce(state, draft => {draft.jobData = action.payload;}),
    [actions.setPage] : (state, action) => produce(state, draft => {draft.page = action.payload;}),
    [actions.setCompare] : (state, action) => produce(state, draft => {draft.compare = action.payload;}),
    [actions.setChar] : (state, action) => produce(state, draft => {draft.char = action.payload;}),
    [actions.setRecentChar] : (state, action) => produce(state, draft => {draft.recentChar = action.payload;}),
}, initialState);